import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Calculates responsive column span classes for a 12-column grid system
 * so that the final row items cleanly expand:
 * - If only 1 box remains in the last row: fills 100% width (col-12)
 * - If 2 boxes remain in the last row: each fills 50% width (col-6)
 * - If the row is complete: preserves normal grid layout
 */
export function getResponsiveCardSpan(index, total) {
  if (!total || total <= 0) return 'col-span-12';

  // Tablet (2-column base on 12-col grid)
  const rem2 = total % 2;
  const isLast1Tablet = rem2 === 1 && index === total - 1;
  const mdClass = isLast1Tablet ? 'md:col-span-12' : 'md:col-span-6';

  // Desktop (3-column base on 12-col grid)
  const rem3 = total % 3;
  let lgClass = 'lg:col-span-4';
  if (rem3 === 1 && index === total - 1) {
    lgClass = 'lg:col-span-12';
  } else if (rem3 === 2 && index >= total - 2) {
    lgClass = 'lg:col-span-6';
  }

  return `col-span-12 ${mdClass} ${lgClass}`;
}
